import { KeyedArray } from "@repo/models";

class SearchResult<T extends ISearchable> {
	search: string;
	matches: T[];
}

export interface ISearchable {
	text: string;
}

export function searchTerms(search: string) {
	return search.toLowerCase().split(/\s+/).filter(Boolean);
}

export class SearchResults<T extends ISearchable> {
	items: T[];
	searchResults: KeyedArray<SearchResult<T>>;

	constructor(items: T[]) {
		this.items = items;
		this.searchResults = new KeyedArray<SearchResult<T>>([], (i) => i.search);
	}

	search(search: string) {
		const key = searchTerms(search).join(" ");
		if (!key) return [];
		const currItems = this.searchResults.get(key);
		if (currItems) return currItems.matches;
		const terms = searchTerms(key);
		const matches = this.getPriorSearches(key).filter((t) => {
			const text = t.text.toLowerCase();
			return terms.every((term) => text.includes(term));
		});

		this.searchResults.set({ search: key, matches });
		return matches;
	}

	// Extending a query only narrows it, so the nearest cached prefix is a safe superset to filter.
	private getPriorSearches(key: string): T[] {
		const prevKey = key.slice(0, -1).trim();

		const prevItems = this.searchResults.get(prevKey);
		if (prevItems) return prevItems.matches;
		if (prevKey) return this.getPriorSearches(prevKey);

		return this.items;
	}
}
